import React, { useMemo } from 'react';

import Skeleton from '@atlaskit/skeleton';

import { useAIAnswerContext } from '../../../../ai-answer-dialog/ai-answer-context';
import type {
	CarouselElement,
	ProjectHighlightElement,
} from '../../../dynamic-layout-parser/types/dynamic-layout-section';
import { DynamicLayoutCarousel } from '../dynamic-layout-carousel';

import type { ProjectHighlightsData } from './subAgentTypes';

const PROJECT_HIGHLIGHTS_SUB_AGENT_NAME = 'PROJECT_HIGHLIGHTS';

export const DynamicLayoutProjectHighlights = (): React.JSX.Element | null => {
	const { loading, dynamicLayoutSubAgentMessages } = useAIAnswerContext();
	const projectHighlightsMessage = useMemo(() => {
		return getSubAgentMessage(dynamicLayoutSubAgentMessages, PROJECT_HIGHLIGHTS_SUB_AGENT_NAME);
	}, [dynamicLayoutSubAgentMessages]);

	const carouselData = useMemo(() => {
		if (!projectHighlightsMessage?.data || projectHighlightsMessage?.data === 'No Data Found') {
			return null;
		}

		try {
			const projectData: ProjectHighlightsData = JSON.parse(projectHighlightsMessage.data);

			const children: ProjectHighlightElement[] = projectData.highlights.map((highlight) => ({
				tag: 'project-highlight-card',
				attributes: {
					title: highlight.title,
					content: highlight.content,
				},
			}));

			const carouselComponent: CarouselElement = {
				tag: 'carousel',
				children,
			};

			return carouselComponent;
		} catch (error) {
			return null;
		}
	}, [projectHighlightsMessage?.data]);

	if (loading && !projectHighlightsMessage?.data) {
		return <Skeleton width="200px" height="16px" isShimmering />;
	}

	if (!projectHighlightsMessage?.data || projectHighlightsMessage?.data === 'No Data Found') {
		return null;
	}

	if (!carouselData) {
		return null;
	}

	return (
		<DynamicLayoutCarousel component={carouselData} position="two-rows-bottom" showArrows={false} />
	);
};

const getSubAgentMessage = (messages: any[], subAgentName: string) => {
	return messages.find((message) => message.sub_agent_name === subAgentName);
};
